import React from "react";
import { StyleSheet, View, Text } from "react-native";
import { colors } from "src/assets";
import LocalText from "src/local";

export type NotFoundProps = {};

export const NotFound: React.FC<NotFoundProps> = ({}) => {
  return (
    <View style={styles.container}>
      <View style={styles.icon}>
        <svg width="67.833" height="80" viewBox="0 0 67.833 80">
          <path
            id="シェイプ_19"
            data-name="シェイプ 19"
            d="M315.64,675.189l5-5.567h46.136l-.006-11.165c0-9.915-6.984-19.828-15.763-22.646l3.981-4.433c9.973,4.369,17.349,15.542,17.349,27.077l.008,16.733Zm-10.975,0-.153-16.708c0-11.99,7.938-23.571,18.479-27.566a21.2,21.2,0,1,1,35.785-20.5l8.677-9.687,4.146,3.714-12.021,13.42q0,.043-.006.086l-17.345,19.312-.028.005-32.938,36.773-.037-.033-1.066,1.187Zm22.283-39.7-.106.03c-9.243,2.36-16.764,12.648-16.764,22.936l.058,6.259,24.577-27.438a21.07,21.07,0,0,1-6.259-2.172C327.921,635.223,327.417,635.351,326.948,635.491ZM322.787,616.4a15.657,15.657,0,0,0,15.64,15.64q.508,0,1.008-.032l14.616-16.318a15.64,15.64,0,0,0-31.265.71Z"
            transform="translate(-304.511 -595.19)"
            fill="#b2b2b2"
          />
        </svg>
      </View>
      <Text style={styles.text}>
        {LocalText.screens.blockedUsers.notFound.text}
      </Text>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  text: {
    marginTop: 31,
    color: colors.black,
    fontSize: 16,
    fontWeight: "bold",
    textAlign: "center",
  },
  icon: {},
});
